import {FC, PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'
import {DataHrItem} from '../../core/_models'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<DataHrItem>>
}

const HrCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={className}
      style={{
        fontSize: '10px',
        fontWeight: 600,
        cursor: 'default',
        userSelect: 'none',
      }}
    >
      {title}
    </th>
  )
}

export {HrCustomHeader}
